import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/travel-styles/private-touring-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/travel-styles/travel-styles-layout.tsx");
